import type { IaHandoffBin } from '../../../types';
import type { LaneConfig } from './types';

/** Gravitational constant (base) */
export const GRAVITY_BASE = 0.38;

/** Velocity damping per frame (6% energy loss) */
export const VELOCITY_DAMPING = 0.94;

/** Duration of descent arc animation in ms */
export const DESCENT_DURATION_MS = 900;

/** Distance threshold for ball consumption by human target */
export const CONSUMPTION_DISTANCE = 10;

/** Wobble sine wave frequency (rad/frame) */
export const WOBBLE_FREQ = 0.04;

/** Ball radius in px; diâmetro visual (CSS) = 2 * radius — alinhar a `.funil-ia-ball` (~29px). */
export const BALL_RADIUS = 14;

/**
 * @deprecated A componente horizontal na descida vive em `stepBall` (arco: esq.→direita
 * / dir.→centro). Mantido 0 para não quebrar *imports* antigos; não usado no arco.
 */
export const DESCENT_FORWARD_PX = 0;

/** Lift amplitude during descent arc */
export const DESCENT_LIFT_AMPLITUDE = 28;

/** Maximum distance for scale/opacity absorption calculation */
export const ABSORPTION_MAX_DIST = 220;

/** Entrance animation duration in ms */
export const ENTRANCE_DURATION_MS = 400;

/** Impulse force per message activity event */
export const IMPULSE_FORCE = 1.2;

/** Impulse deceleration per frame */
export const IMPULSE_DECEL = 0.92;

/** Bola chegou à boca: passa a puxar ao corpo (protótipo GHI-FunilAI). */
export const SUCK_MOUTH_ARRIVAL_PX = 32;

/**
 * Cor do rasto na sucção, por bin (alinhado a HandoffBinsColumn / protótipo).
 * Default em `SUCKED_TRAIL_COLOR` quando `suckTargetBin` não encaixar.
 */
export const HANDOFF_BIN_SUCK_TRAIL: Record<IaHandoffBin, string> = {
  human: '#F43F5E',
  inactive: '#F59E0B',
  lowintent: '#64748B',
  optout: '#0D9488',
  toxic: '#7C3AED',
};

/** Trail spawn chances by visual state */
export const TRAIL_CHANCES: Record<string, number> = {
  idle: 0.14,
  thinking: 0,
  /** Rasto na sucção — partículas mais densas, cor por bin */
  sucked: 0.52,
  /** Rasto na descida entre lanes — mais visível (protótipo) */
  descending: 0.94,
  entering: 0,
  exiting: 0,
};

/** Trail lifetimes by visual state (ms) */
export const TRAIL_LIFETIMES: Record<string, number> = {
  idle: 350,
  thinking: 350,
  sucked: 450,
  descending: 520,
  entering: 350,
  exiting: 350,
};

/** Lane trail colors */
export const LANE_TRAIL_COLORS: Record<string, string> = {
  inicio: '#6366F1',
  em_negociacao_ia: '#A855F7',
  proposta_ia: '#10B981',
};

/** Sucked trail color (rose) */
export const SUCKED_TRAIL_COLOR = '#F43F5E';

/** Alvo / legenda “Humano” (alinhado a `--human` no CSS do funil). */
export const FUNIL_IA_HUMAN_ACCENT = '#F43F5E';

/** Lane configurations */
export const LANE_CONFIGS: LaneConfig[] = [
  {
    key: 'inicio',
    title: 'Início',
    description: 'IA cumprimentando, descobrindo intenção, curso, pergunta e valor.',
    accent: '#6366F1',
    trailColor: '#6366F1',
  },
  {
    key: 'em_negociacao_ia',
    title: 'Em negociação',
    description: 'Lead pedindo descontos ou aprofundando conversa.',
    accent: '#A855F7',
    trailColor: '#A855F7',
  },
  {
    // Mantemos o slug `proposta_ia` para compat de dados persistidos. A label e
    // a descrição mudam: a lane é onde a IA *coleta dados* da proposta — a
    // proposta de fato só sai depois do handoff humano. Vide CRM Manager
    // funnel_stage='coletando_dados' (baseline.v1.yaml > crm_manager_prompts).
    key: 'proposta_ia',
    title: 'Coletando dados',
    description: 'IA coletando campos para proposta — handoff humano segue após.',
    accent: '#10B981',
    trailColor: '#10B981',
  },
];
